import { AlertCircle } from "lucide-react";
import type { ImportPreviewError } from "../types";

type Props = {
  errors: ImportPreviewError[];
};

export function ImportErrorList({ errors }: Props) {
  if (errors.length === 0) return null;
  return (
    <section
      aria-labelledby="import-errors-heading"
      className="rounded-2xl border border-app-red bg-app-red-bg/40 px-4 py-4"
      data-testid="import-error-list"
    >
      <header className="mb-3 flex items-center gap-2 text-app-red">
        <AlertCircle size={18} strokeWidth={2} />
        <h3 id="import-errors-heading" className="font-semibold text-app-red text-sm">
          Filas con error ({errors.length})
        </h3>
      </header>
      <p className="mb-3 text-app-ink-2 text-sm">
        Estas filas no se van a importar. Corregilas en tu archivo CSV y volvé a subirlo.
      </p>
      <ul className="space-y-1.5">
        {errors.map((err, i) => (
          <li
            // biome-ignore lint/suspicious/noArrayIndexKey: errors es estable y no se reordena
            key={i}
            className="flex gap-2 font-mono text-app-ink-1 text-sm tabular-nums"
          >
            <span className="shrink-0 font-medium text-app-red">
              {err.tag ? `${err.tag} · Fila ${err.rowIndex + 2}` : `Fila ${err.rowIndex + 2}`}
            </span>
            <span className="text-app-ink-2">·</span>
            <span className="shrink-0 text-app-ink-3">{err.field}:</span>
            <span className="font-sans text-app-ink-1">{err.message}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
